import {
    I18nManager,
    Platform
} from "react-native";
import type {
    DirectionType
} from "../../types/locale";

export type DocumentDirectionConstantType = {
    direction: DirectionType;
    lang?: string;
};

export type NativeDirectionConstantType = {
    onDirectionChange?: (direction: DirectionType) => void;
    direction: DirectionType;
};

let isRequestedNativeRTL: boolean | undefined;

let isNativeSwapSynced = false;

export const syncDocumentDirection = ({
    direction,
    lang
}: DocumentDirectionConstantType): void => {
    if(Platform.OS !== "web") {
        return;
    }

    const documentElement = globalThis.document?.documentElement;

    if(!documentElement) {
        return;
    }

    documentElement.setAttribute("dir", direction);

    if(lang) {
        documentElement.setAttribute("lang", lang);
    }
};

export const syncNativeDirection = ({
    onDirectionChange,
    direction
}: NativeDirectionConstantType): void => {
    if(Platform.OS === "web") {
        return;
    }

    const isRTL = direction === "rtl";

    if(!isNativeSwapSynced) {
        isNativeSwapSynced = true;

        if(I18nManager.doLeftAndRightSwapInRTL) {
            I18nManager.swapLeftAndRightInRTL(false);
        }
    }

    if(isRequestedNativeRTL === undefined) {
        isRequestedNativeRTL = I18nManager.isRTL;
    }

    if(isRequestedNativeRTL === isRTL) {
        return;
    }

    isRequestedNativeRTL = isRTL;

    I18nManager.allowRTL(isRTL);

    I18nManager.forceRTL(isRTL);

    if(I18nManager.isRTL !== isRTL) {
        onDirectionChange?.(direction);
    }
};
